<script setup lang="ts">
import { RouterView } from 'vue-router';
import SessionProlongDialog from '@/components/ProlongationDialog.vue'
import SessionDialog from '@/components/SessionDialog.vue'
import { useUserStore } from '@/store/useUserStore';

const UserStore = useUserStore();
</script>

<template>
  <RouterView />
  <SessionProlongDialog v-if="UserStore.isProlongationDialogOpen" />
  <SessionDialog v-if="UserStore.isSessionDialogOpen" />
</template>

